import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackGtmPageView } from '@/analytics/gtm'

/**
 * Sends a dataLayer `pageview` on client-side route changes (SPA).
 */
const GtmRouteTracker = () => {
  const location = useLocation()

  useEffect(() => {
    trackGtmPageView(location.pathname + location.search)
  }, [location])

  return null
}

export default GtmRouteTracker
